<template>
  <div class="overlay" v-if="showIt == true">
    <div class="overlay-bg" @click="closeOverlay()"></div>
    <div class="d-flex justify-content-center full-height">
      <div class="keywords-card ">
        <form @submit.prevent="checkForm">
          <h2>{{$t('send')}}</h2>
          <div class="form-wrap">
            <div class="form-body">
              <div class="row mb-3">
                <div class="col-12">
                  <label>{{$t('email-address')}}</label>
                  <input
                    id="email"
                    type="email"
                    name="email" value=""
                    autocomplete="email"
                     v-model="userData.email"
                     class="form-control keywords-search" :placeholder="$t('email-address')"
                    :class="{ unvalid: !isDisable(), valid: isDisable() }"
                  >
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12 text-center">
                  {{choosenPromoCode}}
                </div>
              </div>
              <div class="row">
                <div class="d-flex justify-content-center submit-btn">
                  <button type="button" name="button" class="btn btn-primary full" :disabled="!isDisable()" @click="sendInvite()">{{$t('send')}}</button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "AddUser",
  props: ["choosenPromoCode"],
  data() {
    return {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('access_token'),
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin'
      },
      url: this.$store.getters.enviromentURL + '/sendPromo',
      keywordPreview: null,
      userData:{}
    }
  },
  beforeDestroy() {
    this.closeOverlay();
  },
  mounted() {
  },
  computed: {
    showIt() {
      //console.log('?????');
      return this.$store.getters.addUserOpen;
    }
  },
  watch: {
  },
  methods: {
    checkForm(e) {
      if (
        this.userData.email && this.userData.email.includes( '@' )
      ) {
        this.submitForm();
      } else {
        e.preventDefault();
      }
    },
    isDisable() {
      if (
        this.userData.email && this.userData.email.includes( '@' )
      ) {
        return true;
      } else {
        return false;
      }
    },
    addHash(original) {
      var url = original + '?' + Math.floor(Math.random() * 1000000);
      return url
    },
    sendInvite() {
      //console.log('submitNow edited keyword', this.userData.email, this.choosenPromoCode);

      axios.put(this.url, { email: this.userData.email, promoCode: this.choosenPromoCode }, {
        headers: this.headers
      })
          .then(response => {
            //console.log('submitNow Response =')
            if (response.data != null) {
              //console.log('response', response.data );

              this.$store.commit('updateSuccessOpen', true)
              this.closeOverlay()
            }
          })
          .catch(e => {
            //console.log( JSON.stringify( e ) );
            this.errors.push(e)
          })
    },
    closeOverlay() {
      this.userData.email = '';
      this.$store.commit('addUserOpen', false)
    },
    handleProcessFilePreview: function (error, file) {
      //console.log('done', file);
      var response = JSON.parse(file.serverId);
      //console.log('filename', response.filename);
      this.keywordPreview = response.filename;
      //console.log('this.prize.giveaway', this.prize.giveaway);
    }
  }
}
</script>

<style scoped>
.submit-btn {
  margin: 1em auto -1em auto;
}

.placeholder::-webkit-input-placeholder {
  color: #888888;
  opacity: 1;
}

.placeholder:-ms-input-placeholder {
  color: #888888;
  opacity: 1;
}

.placeholder::-ms-input-placeholder {
  color: #888888;
  opacity: 1;
}

.placeholder::placeholder {
  color: #888888;
  opacity: 1;
}

.unvalid {
  border-color: #ff5252;
}

.valid {
  border-color: #68d312;
}
</style>